/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Gets SDExternalUserRenewalStatus from api:
 * /v1/ua/sd_externaluser_renewal_status
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchSdExternaluserRenewalStatusUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/sd_externaluser_renewal_status`,
    models.SDExternalUserRenewalStatus
  );
};

/**
 * Gets UAApplicationFormIdentifier from api:
 * /v1/ua/sd_renewal_application_form
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchSdRenewalApplicationFormUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/sd_renewal_application_form`,
    models.UAApplicationFormIdentifier
  );
};

/**
 * Gets UAApplicationFormIdentifier from api:
 * /v1/ua/sdcca_cca_renewal_application_form
 *
 * @param {any} callback function to call once this function has finished
 */
const fetchSdccaCcaRenewalApplicationFormUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/sdcca_cca_renewal_application_form`,
    models.UAApplicationFormIdentifier
  );
};

export {
  fetchSdExternaluserRenewalStatusUtil,
  fetchSdRenewalApplicationFormUtil,
  fetchSdccaCcaRenewalApplicationFormUtil,
};
